import { type FieldValues, type UseControllerProps, useController } from 'react-hook-form';

import { type SearchSelectionProps, SearchSelection } from '../SearchSelection';

type FormSearchSelectionProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  SearchSelectionProps;

function FormSearchSelection<TFieldValues extends FieldValues = FieldValues>(
  props: FormSearchSelectionProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <SearchSelection
      {...field}
      {...props}
      value={field.value ?? null}
      error={!!error}
      required={!!props.required}
      helperText={error?.message ?? props.helperText ?? null}
      onChange={(event, item, reason, details) => {
        field.onChange(item ?? null);
        if (props.onChange) {
          props.onChange(event, item, reason, details);
        }
      }}
      onBlur={(event) => {
        props.onBlur?.(event);
        field.onBlur();
      }}
      inputRef={ref}
    />
  );
}

export { FormSearchSelection };
export type { FormSearchSelectionProps };
